import React from "react";
import { ContinueText } from "./WebSocketAudioHandler.styles";

const NextQuestionButton = ({
  showNextQuestion,
  isLoadingNextQuestion,
  handleNextQuestionClick,
}) => {
  return (
    <>
      <ContinueText
        className={showNextQuestion ? "show" : ""}
        onClick={() => {
          if (isLoadingNextQuestion) return;
          handleNextQuestionClick(isLoadingNextQuestion);
        }}
      >
        {isLoadingNextQuestion && (
          <span className="spinner-border spinner-border-sm mr-2"></span>
        )}
        CLICK HERE TO END THIS CONVERSATION
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="21"
          height="20"
          viewBox="0 0 21 20"
          fill="none"
        >
          <path
            d="M3.83398 10H17.1673M17.1673 10L12.1673 5M17.1673 10L12.1673 15"
            stroke="white"
            strokeWidth="1.25"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </ContinueText>
    </>
  );
};

export default NextQuestionButton;